var _path, _path2, _circle, _path3, _path4, _g, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLocation = function SvgLocation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#CFCFCF",
    d: "M0 0h43v43H0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#location_svg__a)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M-165-1266h1440V861H-165z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 21.5,
    r: 21.5,
    fill: "#F2FAF1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.965 15.764a7.248 7.248 0 0 0-6.515-4.002 7.077 7.077 0 0 0-3.258.784c-1.729.865-2.996 2.373-3.619 4.243-.604 1.85-.463 3.86.382 5.529.946 1.87 5.248 7.059 5.731 7.641l.764.905.744-.925c.2-.24 4.705-5.73 5.73-7.6 1.126-2.012 1.126-4.404.04-6.575Z",
    fill: "#58B847"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "location_svg__b",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 11,
    width: 17,
    height: 21
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.441 11h16.095v20.626H13.441V11Z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#location_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.45 12.525a6.36 6.36 0 0 0-2.912.7c-1.528.765-2.678 2.116-3.242 3.806-.538 1.649-.415 3.453.34 4.943.83 1.645 4.511 6.139 5.62 7.477l.18.214.164-.204c.755-.908 4.744-5.826 5.657-7.489.994-1.777 1.002-3.914.025-5.867a6.494 6.494 0 0 0-5.833-3.58Zm0 19.101a.762.762 0 0 1-.583-.271l-.764-.904c-1.476-1.782-4.95-6.051-5.829-7.789-.935-1.847-1.09-4.074-.426-6.109.693-2.081 2.115-3.744 4.002-4.689a7.869 7.869 0 0 1 3.6-.864 8.013 8.013 0 0 1 7.196 4.422c1.207 2.413 1.187 5.07-.057 7.289-1.083 1.976-5.763 7.66-5.808 7.716l-.738.916a.766.766 0 0 1-.585.283h-.009Z",
    fill: "#58B847"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.31 18.49a2.823 2.823 0 1 1-5.644 0 2.823 2.823 0 0 1 5.645 0Z",
    fill: "#F2FAF1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "location_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(-165 -1266)",
    d: "M0 0h1440v2127H0z"
  })))));
};
export default SvgLocation;